import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import App from '../components';

const mapStateToProps = (state) => {
    const { authentication } = state
    const { status = '' } = authentication

    return {
        authStatus: status
    };
};

export default withRouter(connect(mapStateToProps, null)(App));